import { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { RECAPTCHA_SITE_KEY } from '../config';

/* The API runs `verifyRecaptcha` on /auth/register and on BOTH shapes of
   /api/v1/contact, so those three forms cannot submit without a token unless
   the site is being reached over a bare IP (the middleware skips that case).

   With no site key configured the widget can't render, so we render nothing
   and let the request go out tokenless — the server then answers with a plain
   "Please complete the reCAPTCHA" that the API client surfaces verbatim. That
   keeps local development usable without pretending the form succeeded. */

export const CAPTCHA_ENABLED = !!RECAPTCHA_SITE_KEY;

/** Message to show when the widget is on screen but untouched. */
export const CAPTCHA_PROMPT = 'Please complete the reCAPTCHA verification.';

const Captcha = forwardRef(function Captcha({ onChange, style }, ref) {
  if (!CAPTCHA_ENABLED) return null;
  return (
    <div style={{ marginTop: '16px', ...style }}>
      <ReCAPTCHA
        ref={ref}
        sitekey={RECAPTCHA_SITE_KEY}
        onChange={onChange}
        onExpired={() => onChange(null)}
        onErrored={() => onChange(null)}
      />
    </div>
  );
});

export default Captcha;
